
const SECURITY_KEY_LIST_LIST = 'SECURITY_KEY_LIST_LIST';
const SECURITY_KEY_LIST_PAGE = 'SECURITY_KEY_LIST_PAGE';
const SECURITY_KEY_LIST_CONDITION = 'SECURITY_KEY_LIST_CONDITION';
const SECURITY_KEY_LIST_ADD_CONDITION = 'SECURITY_KEY_LIST_ADD_CONDITION';

const SecurityKeyListModel = function () {
  const name = 'securitykey';
  return {
    name,
    state: {
      list: [],
      condition: {
        name: '',
      },
      addCondition:{
        mchNo:'',
        forinsmid:'',
        forinsid:'',
        apikey:'',
        payway:'',
      },
      page: {
        cur_page: 1,
        size: 30,
        total: 0
      }
    },
    selectors: (state) => {
      const currentState = state[name];
      const selectors = {
        getList: () => currentState.list,
        getPage: () => currentState.page,
        getCondition: () => currentState.condition,
        getAddCondition: () => currentState.addCondition,
      };
      return selectors;
    },
    actions: {
      changeList: (list) => (dispatch, getState) => {
        dispatch({
          type: SECURITY_KEY_LIST_LIST,
          list
        });
      },
      changePage: (page) => (dispatch, getState) => {
        dispatch({
          type: SECURITY_KEY_LIST_PAGE,
          page
        });
      },
      changeCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: SECURITY_KEY_LIST_CONDITION,
          key,
          value
        });
      },
      changeAddCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: SECURITY_KEY_LIST_ADD_CONDITION,
          key,
          value
        });
      },
    },
    reducers: {
      list: (state = SecurityKeyListModel.state.list, action) => {
        if (action.type === SECURITY_KEY_LIST_LIST) {
          return [...action.list];
        }
        return state;
      },
      page: (state = SecurityKeyListModel.state.page, action) => {
        if (action.type === SECURITY_KEY_LIST_PAGE) {
          return Object.assign({}, state, action.page);
        }
        return state;
      },
      condition: (state = SecurityKeyListModel.state.condition, action) => {
        if (action.type === SECURITY_KEY_LIST_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      },
      addCondition: (state = SecurityKeyListModel.state.addCondition, action) => {
        if (action.type === SECURITY_KEY_LIST_ADD_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      }
    }
  };
}();

export default SecurityKeyListModel;


// WEBPACK FOOTER //
// ./src/models/SecurityKeyListModel.js